import React from "react";
import { useStepper } from "../ui/stepper";

export const LandingLpIntroHeader = () => {
  const { currentStep } = useStepper();

  return (
    <div className="h-[var(--header-height)] border-b bg-background-500">
      <div className="h-full w-full flex form-container justify-center items-center">
        <div className="flex items-center gap-2">
          <img
            src={"/assets/heart_logo.png"}
            alt="heart logo icon"
            className="size-8"
          />
          <h1 className="text-xl font-bold">Nectar AI</h1>
        </div>
      </div>
    </div>
  );
};
